import { combineReducers } from 'redux';
import config from './ConfigReducer';
import header from './HeaderReducer';
import sidebar from './SidebarReducer';
import hotelList from './HotelListReducer';
import buildingList from './BuildingListReducer';
import floorList from './FloorListReducer';
import roomList from './RoomListReducer';
import doorlockList from './DoorlockListReducer';
import bookingList from './BookingListReducer';
import staffList from './StaffListReducer';
import reportList from './ReportListReducer';
import doorlockTileList from './DoorlockTileListReducer'; //도어락 타일형 추가

const rootReducer = combineReducers({
  config,
  header,
  sidebar,
  hotelList,
  buildingList,
  floorList,
  roomList,
  doorlockList,
  doorlockTileList,
  bookingList,
  staffList,
  reportList,
});

export default rootReducer;
